import React from "react";
import { useGet } from "./api";
import { isTextNullOrEmpty } from "./utils";
import { subscribe, unsubscribe } from "./pubSub";

export default function AgencyName({ id }) {
  const { data, loading, error, refetch } = useGet(id);

  React.useEffect(() => {
    subscribe("agency.agencyDetails.updated", refetch);
    return () => unsubscribe("agency.agencyDetails.updated", refetch);
  }, [id]);

  if (loading) return <>Loading...</>;

  function handleRender() {
    if (!isTextNullOrEmpty(error)) return <>{String(error)}</>;

    if (data != null && !data.isSuccess) {
      return data.errors.map((error) => <>{error}</>);
    }

    return (
      <>
        {data?.value?.agencyNumber} {data?.value?.name}
      </>
    );
  }

  return <>{handleRender()}</>;
}
